<template>
    <div class="health-box">
        <div class="radio-box">
            <van-radio-group v-model="radio" direction="horizontal">
                <van-radio :name="false" @click="onChangeRadio">暂无</van-radio>
                <van-radio :name="true" @click="onChangeRadio">有</van-radio>
            </van-radio-group>
        </div>
        <div v-if="radio">
            <div class="checkbox-box" v-if="filterOptions.length > 0">
                <van-checkbox-group v-model="checkList" @change="onChangeGroupCheckbox">
                    <van-checkbox :name="item" v-for="(item, index) in filterOptions" :key="index"
                        :class="checkList.includes(item) ? 'checkbox-active' : ''">
                        {{ item }}
                    </van-checkbox>
                </van-checkbox-group>
                <van-checkbox label="其他" v-model="checkOther" @change="onChangeCheckbox"
                    :class="checkOther ? 'checkbox-active' : ''">其他</van-checkbox>
            </div>
            <van-field label="" v-show="checkOther || filterOptions.length === 0" @blur="onInputBlur" v-model="input"
                class="input-box" placeholder="请补充输入内容" maxlength="32" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'HealthCheckbox',
    props: {
        select: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            radio: false,
            checkList: [],
            input: '',
            checkOther: false
        }
    },
    computed: {
        filterOptions() {
            return this.options.filter((item) => !['暂无', '其他'].includes(item))
        }
    },
    methods: {
        // group bug
        onChangeRadio() {
            this.onEmitSelect(this.radio ? '' : '暂无')
            this.checkList = []
            this.input = ''
        },
        onChangeGroupCheckbox(arr) {
            this.onEmitSelect([...arr, this.input].filter((item) => !!item).join('|'))
        },
        onInputBlur() {
            const result = this.checkList.filter(
                (item) => item !== this.input
            )
            this.onEmitSelect([...result, this.input].filter((item) => item).join('|'))
        },
        onChangeCheckbox() {
            this.input = this.checkOther ? this.input : ''
            this.onEmitSelect(
                this.checkList
                    .filter((item) => item !== this.input)
                    .join('|')
            )
        },
        onEmitSelect(value) {
            this.$emit("update:select", value);
        }
    },
    watch: {
        select: {
            handler() {
                let list = []
                this.radio = this.select !== '暂无';
                (this.select || '').split('|').forEach(item => {
                    if (this.filterOptions.includes(item)) {
                        list = [...list, item]
                    } else {
                        this.input = item === '暂无' ? '' : item
                    }
                })
                this.checkList = list;
                this.checkOther = !!this.input
            },
            immediate: true,
        },
    }
}
</script>
<style lang="scss" scoped>
.health-box {
    width: 100%;
    position: relative;

    .radio-box {
        position: absolute;
        top: -27px;
        right: 0;
    }

    :deep(.checkbox-box) {

        .van-checkbox-group {
            display: inline;
        }

        .van-checkbox {
            margin-right: 10px;
            padding: 4px 14px;
            border-radius: 14px;
            border: 1px solid #DDDDDD;
            background: #fff;
            margin-top: 10px;
            display: inline-flex;

            .van-icon {
                display: none;
            }

            .van-checkbox__label {
                margin-left: 0;
                color: #888888;
            }
        }

        .checkbox-active {
            border: 1px solid #0082ef !important;
            background: #eff3fb !important;

            .van-checkbox__label {
                color: #0082ef !important;
            }
        }
    }

    .input-box {
        margin-top: 10px;
        border-radius: 24px;
        background: #f5f5f5;
        padding: 8px 15px;
    }
}
</style>